// ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from './firebaseAuth';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuthState();

  if (loading) {
    return <p>Loading...</p>; 
  }

  return user ? children : <Navigate to="/live-streaming" />;
};

export default ProtectedRoute;
